<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="surveyList"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="surveyListForm"
          :redirect-detail="true"
          :show-add-button="false"
          caption="<i class='fa fa-align-justify'></i> Daftar Survey"
        ></global-table>
      </b-col>

      
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      surveyList: [],
      loading: true,
      loadingSubmit: false,
      surveyListForm: null,
      fields: [
        {
          key: "unique_code",
          label: "Kode Unique",
          class: "width-150",
          sortable: true
        },
        { key: "customer_name", label: "Nama Konsumen", class: "width-150", sortable: true },
        {
          key: "employee_name",
          label: "Nama Karyawan",
          class: "width-150",
          sortable: true
        },
        {
          key: "date_survey",
          label: "Tanggal Survey",
          class: "width-100",
          sortable: true
        },
        { key: "action", class: "width-50 text-center" }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    surveyListForm: {
      name: { required },
      surename: {},
      username: {},
      email: { required },
      start_join: { required },
      end_date: {},
      mobile_phone: { required },
      division_id: { required },
      position_id: { required },
      payment_method: { required },
      bank_account_number: { required },
      bank_account_name: {},
      bank_name: {},
      parent: {},
      status: {},
      address: {},
      id_number: { required },
      religion: { required },
      employee_ho: { required }
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllSurvey();
    },
    getAllSurvey: function() {

      this.axios
        .post("web/survey/all-freezer/", {perPage: 10})
        .then(response => {
          this.surveyList = response.data.data;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>